<template>
  <v-container text-center>
    <v-btn
      v-if="Object.values(selectedSurvey).length !== 0"
      color="primary"
      :disabled="noData"
    >
      <JsonCSV
        :data="formatCSV() || []"
        :name="getCSVName()"
      >
        Export Responses
      </JsonCSV>
    </v-btn>
  </v-container>
</template>
<script>
import moment from "moment";
import JsonCSV from "vue-json-csv";
import { mapState } from "vuex";

export default {
  name: "SurveyResponsesExport",
  components: {
    JsonCSV
  },
  data() {
    return {
      noData: false,
      string: "Responses.csv"
    };
  },
  computed: {
    ...mapState({
      selectedSurvey: state => state.survey.selectedSurvey,
      filteredResponsesBasedFilterOptions: state =>
        state.surveyResponseFiltering.filteredResponsesBasedFilterOptions,
      stakeholders: state => state.surveyResponseFiltering.stakeholders
    })
  },
  methods: {
    getCSVName() {
      return this.selectedSurvey.name + " Responses.csv";
    },
    getStakeholder(stakeholderPK) {
      return this.stakeholders.find(
        stakeholder => stakeholder.pk === stakeholderPK
      ).get_full_name_with_postal_code;
    },
    responseTimestamp(timestamp) {
      let format = "MMMM Do YYYY, h:mm a";
      return moment(timestamp)
        .local()
        .format(format);
    },
    cleanArray(csvWithColumns, row) {
      // if the row still contains an question key in the row then remove it. e.g. HowDidYouHear-Comment but didnt have an other comment
      const keysToCheck = csvWithColumns[0].slice();
      keysToCheck.splice(3).forEach(question => {
        if (row.indexOf(question) !== -1) {
          row[row.indexOf(question)] = "";
        }
      });
      return row;
    },
    generateColumnns() {
      const csvWithColumns = [];
      csvWithColumns.push(["Survey", "Stakeholder", "Timestamp"]);
      this.selectedSurvey.survey_json.pages.forEach((pages, index) => {
        const elements = this.selectedSurvey.survey_json.pages[index][
          "elements"
        ];
        elements.forEach(element => {
          csvWithColumns[0].push(element.name);
          if (Object.prototype.hasOwnProperty.call(element, "hasOther")) {
            csvWithColumns[0].push(element.name + "-Comment");
          }
        });
      });
      return csvWithColumns;
    },
    generateRows(csvWithColumns) {
      this.filteredResponsesBasedFilterOptions.forEach(response => {
        let arrayToPush = [...csvWithColumns[0]];
        // getSurvey()
        arrayToPush[0] = [this.selectedSurvey.name];
        arrayToPush[1] = this.getStakeholder(response.survey_taker_id);
        arrayToPush[2] = this.responseTimestamp(response.timestamp);
        // add responseData to correct column, loop through question keys
        // get the index of said question key and replace the text with the answer to question
        Object.keys(response.response_json).forEach(question => {
          arrayToPush[arrayToPush.indexOf(question)] =
            response.response_json[question];
        });
        // clean the array before push
        arrayToPush = this.cleanArray(csvWithColumns, arrayToPush);

        csvWithColumns.push(arrayToPush);
      });
      return csvWithColumns;
    },
    formatCSV() {
      if (this.filteredResponsesBasedFilterOptions.length > 0) {
        this.noData = false;
        const csvWithColumns = this.generateColumnns();
        const formattedCSV = this.generateRows(csvWithColumns);
        return formattedCSV;
      } else {
        this.noData = true;
      }
    }
  }
};
</script>
